import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { reducer as deliveryReducer } from '../scenes/Customer/scenes/Deliveries/reducer';
import { reducer as customerUploadReducer } from '../scenes/Customer/scenes/Upload/reducer';
import { reducer as adminReducer } from '../scenes/Admin/reducer';
import { reducer as fileProgressReducer } from '../data/fileProgress/reducer';
import { reducer as userReducer } from '../data/user/reducer';
import * as MiseAuth from "mise-react-redux-auth0-2";
import stepBuilderReducer from './slices/stepBuilderSlice';

const { authReducer, callbackReducer } = MiseAuth;

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'auth'],
};

const rootReducer = combineReducers({
  Admin: adminReducer,
  deliveries: deliveryReducer,
  stepBuilder: stepBuilderReducer,
  customerUpload: customerUploadReducer,
  fileProgress: fileProgressReducer,
  user: userReducer,
  auth: authReducer,
  callback: callbackReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStoreFunc(initialState) {
  const store = configureStore({
    reducer: persistedReducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        },
      }),
    devTools: import.meta.env.DEV,
  });

  return store;
}

export function persistor(store) {
  return persistStore(store);
}
